<template lang="pug">
button.btn.btn-default.btn-block(
  type="button"
  :class="{ active: selected }"
  :value="value"
  :disabled="disabled"
  @click.prevent="onClick"
)
  | {{ text }}
</template>

<script>
export default {
  name: 'AppRadioButton',
  props: {
    value: {
      type: Number,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('input', this.value);
      }
    },
  },
};
</script>
